import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _ from "lodash";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { IModal } from "../../stores";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { ShowAlert } from "../../utils/functions";
import { IDeliveryDriver, VehicleType } from "../../stores/delivery/index.d";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBicycle,
  faCarAlt,
  faEdit,
  faMotorcycle,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";

const DriverForm = observer(({ show, setShowModal }: IModal) => {
  const { deliveryStore } = useStores();
  const { editDriver, fetchDrivers, saveDriver } = deliveryStore;
  const [driver, setDriver] = useState<IDeliveryDriver>(
    editDriver ?? {
      deliveryDriverId: 0,
      name: "",
      vehicleRegNumber: "",
      vehicleType: VehicleType.Car,
      contactNumber: "",
      altContactNumber: "",
    }
  );
  const [isFormValid, setIsFormValid] = useState(true);
  const isEditRequest = editDriver != null && editDriver.deliveryDriverId > 0;

  const validateForm = () => {
    const isValid =
      driver.name &&
      driver.vehicleRegNumber &&
      driver.vehicleType &&
      driver.contactNumber
        ? true
        : false;

    setIsFormValid(isValid);
  };

  useEffect(() => {
    validateForm();
  }, [driver]);

  const submitCallback = useCallback((res: boolean) => {
    if (res) {
      setShowModal(false);
      fetchDrivers();
      ShowAlert.Success(
        `Driver ${isEditRequest ? "updated" : "added"} successfully.`
      );
    } else {
      ShowAlert.Error("Request failed. Please try again.");
    }
  }, []);

  const handleFormSubmit = () => {
    if (!isFormValid) {
      ShowAlert.Error("One or more field value missing.");
      return;
    }

    saveDriver(driver, submitCallback);
  };

  const handleInputChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const { id, value } = evt.target;
    setDriver((prev) => ({ ...prev, [id]: value }));
  };

  const handleRadioChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target;
    setDriver((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Modal show={show} onHide={() => setShowModal(false)}>
      <ModalHeader closeButton>
        <Modal.Title>
          <h5>{isEditRequest ? "Update" : "Add"} Delivery Driver</h5>
        </Modal.Title>
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="name"
              placeholder="Driver Name"
              value={driver.name}
              required
              onChange={handleInputChange}
            />
            <label htmlFor="name">Driver Name</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="vehicleRegNumber"
              placeholder="Vehicle Reg. Number"
              value={driver.vehicleRegNumber}
              required
              onChange={handleInputChange}
            />
            <label htmlFor="vehicleRegNumber">Vehicle Reg. Number</label>
          </div>
          <div className="mb-3">
            <div className="ps-1 form-check form-check-inline h6">
              <label>Vehicle Type</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="vehicleType"
                id="inlineRadio1"
                value="1"
                checked={driver.vehicleType == VehicleType.Car}
                onChange={handleRadioChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio1">
                <FontAwesomeIcon icon={faCarAlt} className="fs-3" />
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="vehicleType"
                id="inlineRadio2"
                value="2"
                checked={driver.vehicleType == VehicleType.Bike}
                onChange={handleRadioChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio2">
                <FontAwesomeIcon icon={faMotorcycle} className="fs-3" />
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="vehicleType"
                id="inlineRadio3"
                value="3"
                checked={driver.vehicleType == VehicleType.Bicycle}
                onChange={handleRadioChange}
              />
              <label className="form-check-label" htmlFor="inlineRadio3">
                <FontAwesomeIcon icon={faBicycle} className="fs-3" />
              </label>
            </div>
          </div>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="contactNumber"
              placeholder="Contact Number"
              value={driver.contactNumber}
              required
              onChange={handleInputChange}
            />
            <label htmlFor="contactNumber">Contact Number</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="altContactNumber"
              placeholder="Alt. Contact Number"
              value={driver.altContactNumber}
              required
              onChange={handleInputChange}
            />
            <label htmlFor="altContactNumber">Alt. Contact Number</label>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-default flex-fill"
          onClick={handleFormSubmit}
          disabled={!isFormValid}
        >
          {isEditRequest ? (
            <>
              <FontAwesomeIcon icon={faEdit} className="me-2" />
              <span>Update Driver Details</span>
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              <span>Add Driver</span>
            </>
          )}
        </button>
      </ModalFooter>
    </Modal>
  );
});

export default DriverForm;
